import { render, staticRenderFns } from "./index.vue?vue&type=template&id=afaea220&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=afaea220&prod&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=afaea220&prod&lang=less&scoped=true"
import style2 from "./index.vue?vue&type=style&index=2&id=afaea220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afaea220",
  null
  
)

export default component.exports